import { useCacheSlice } from '../hooks'

export type BillingCategory =
  | 'hourly'
  | 'flat_rate'
  | 'pro_bono'
  | 'administrative'
  | 'internal'
  | 'unknown'

export type BillableCategory =
  | 'billable'
  | 'non_billable'
  | 'billable_credit'
  | 'unknown'

export type Matter = {
  matter: string
  matter_id: string
  client: string
  description: string
  task_group: string
  activity_group: string
  is_recent?: number
  recency_rank?: number | null
  billing_category: BillingCategory
  billable_category: BillableCategory
}

export function useMattersCache() {
  const { data, isLoading, lastFetchedAt } = useCacheSlice('matters')
  const matters = data as Matter[]
  // Only signal loading on the initial fetch — background refetches (window focus,
  // etc.) should not affect taskRequired/activityRequired derived state.
  const isInitialLoading = isLoading && lastFetchedAt === 0
  return { matters, isLoading: isInitialLoading }
}
